




































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VueEditor } from 'vue2-editor';
import { VbSnackbarService } from 'bag-of-holding-library';
import KeyArea from '@/domain/drd-2.0/entity/key-area.entity';
import Rules from '@/shared/rules/rules';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Level from '@/domain/drd-2.0/entity/level.entity';
import Skill from '@/domain/drd-2.0/entity/skill.entity';
import KeyAreaService from '@/domain/drd-2.0/service/key-area.service';
import KeyAreaSkillLevel from '@/domain/drd-2.0/entity/key-area-skill-level.entity';
import KeyAreaSkill from '@/domain/drd-2.0/entity/key-area-skill.entity';
import AutocompleteEditableItems from '@/shared/autocompletes/autocomplete-editable-items.vue';
import Loading from '@/shared/loading/loading.component.vue';
import Indicators from '@/domain/drd/entity/indicators.entity';
import DrawerComponent from '@/shared/drawer/drawer.component.vue';
import ToolbarConfig from './toolbar-config.json';
import SkillTypes from '../../skill/skill-types.json';
import SelectSkillsDialog from './select-skills-dialog.component.vue';
import KeyAreaSkillForm from './skill-form.component.vue';
import IndicatorsComponent from '../../components/indicators.component.vue';
import ResponsibilityTreeComponent from '../../responsibility/responsibility-tree.component.vue';
import ResponsibilityFormComponent, { ResponsibilityText } from '../../responsibility/responsibility-form.component.vue';
import SkillTreeComponent from '../../components/skill-tree.component.vue'
import SelectSkillDrawer from '../../components/select-skill-drawer.component.vue';

@Component({
  components: {
    LabelSlot,
    SelectSkillsDialog,
    VueEditor,
    AutocompleteEditableItems,
    Loading,
    KeyAreaSkillForm,
    IndicatorsComponent,
    ResponsibilityTreeComponent,
    ResponsibilityFormComponent,
    SkillTreeComponent,
    DrawerComponent,
    SelectSkillDrawer,
  },
})
export default class FormComponent extends Vue {
  @Prop({
    required: true,
  }) keyArea!: KeyArea;

  @Prop({
    type: Boolean,
    default: false,
  }) isUpdate!: boolean;

  get tab() {
    return this.$route.query.tab ? Number(this.$route.query.tab) : 0;
  }

  set tab(value: number) {
    this.$router.push({ query: { ...this.$route.query, tab: String(value) } });
  }

  levelsSelected: Level[] = [];

  rules: Rules = new Rules();

  toolbar = ToolbarConfig;

  skillTypes = SkillTypes;

  openSkillDrawer: boolean = false;

  keySkillList = 0;

  get skillTypesActiveOrdered() {
    return this.skillTypes
      .filter(type => type.active)
      .sort((a, b) => a.order - b.order);
  }

  openSelectSkillDialog: boolean = false;

  levels: Level[] = [];

  editing: Level = { id: '', name: '', disabled: false };

  editingIndex = -1;

  loadingUpdateLevel: boolean = false;

  loadingDeleteLevel: boolean = false;

  levelSearchName: string = '';

  loadingCreateLevel: boolean = false;

  responsibilityOptions: any = [];

  showConfig: boolean = false;

  languageOptions = [
    {
      text: 'Português',
      value: 'PTBR',
    },
    {
      text: 'Inglês',
      value: 'EN',
    },
    {
      text: 'Espanhol',
      value: 'ES',
    },
  ]

  languageSelected = 'PTBR';

  getResponsibilityOptions() {
    KeyAreaService.getResponsiblesOptions()
      .then((data) => {
        this.responsibilityOptions = data;
      })
  }

  editLevel(index: number, item: Level) {
    if (this.editing !== item) {
      this.editing = item;
      this.editingIndex = index;
      return;
    }
    this.resetEditLevel();
  }

  resetEditLevel() {
    this.editing = { id: '', name: '', disabled: false };
    this.editingIndex = -1;
  }

  created() {
    this.getResponsibilityOptions()
    this.getAllLevels();
  }

  getOptionsBySkillType(type: string) {
    return this.skillTypes.filter(it => it.value === type)[0].options
      .filter(it => it.isSelected);
  }

  addLevel(level: Level, skill: KeyAreaSkill) {
    const skillFiltered = this.keyArea.skills
      .filter(it => it.skill.id === skill.skill.id)[0];
    const levelAlreadyAdded = skillFiltered.levels
      .filter(it => it.name === level.name);
    if (levelAlreadyAdded.length > 0) return;
    this.$emit('addLevel', { level, skillFiltered });
  }

  disableOrActiveLevel(skill: KeyAreaSkill, level: KeyAreaSkillLevel) {
    this.$emit('disableOrActiveLevel', { skill, level });
  }

  removeLevel(skill: KeyAreaSkill, level: KeyAreaSkillLevel) {
    this.$emit('removeLevel', { skill, level });
  }

  get selectedSkills() {
    return this.keyArea.skills.map(it => it.skill);
  }

  addSkillToKeyArea(skill: Skill) {
    this.$emit('addSkill', { skill, levels: this.levelsSelected });
  }

  skillSelected(skill: Skill, selected: boolean) {
    if (selected) {
      this.$emit('addSkill', { skill, levels: this.levelsSelected });
      return;
    }
    this.emitRemoveSkill(skill.id);
  }

  emitRemoveSkill(skillId: string) {
    this.$emit('removeSkill', skillId);
  }

  filterSkillsByType(type: string) {
    if (this.keyArea.skills.length === 0) return [];
    return this.keyArea.skills.filter(it => it.skill.type === type && it.active);
  }

  async getAllLevels() {
    await KeyAreaService.findAllLevels()
      .then(levels => this.levels = levels);
    this.levelsSelected = this.keyArea.skills.length > 0
      ? this.levels.filter(it => this.keyArea.levels.some(lv => lv.id === it.id))
      : [];
  }

  updateLevel(level: Level) {
    this.loadingUpdateLevel = true;
    KeyAreaService.updateLevel(level)
      .then(() => {
        VbSnackbarService.showSuccess('Nível atualizado!');
      }).catch((err) => {
        VbSnackbarService.showError(err.response.data.messages.toString());
      }).finally(() => {
        this.loadingUpdateLevel = false;
        this.resetEditLevel();
      });
  }

  deleteLevel(level: Level) {
    this.loadingDeleteLevel = true;
    KeyAreaService.deleteLevel(level.id)
      .then(() => {
        VbSnackbarService.showSuccess('Nível excluído!');
      }).catch((err) => {
        VbSnackbarService.showError(err.response.data.messages.toString());
      }).finally(() => {
        this.resetEditLevel();
        this.getAllLevels();
        this.loadingDeleteLevel = false;
      });
  }

  createLevel(levelName: string) {
    this.loadingCreateLevel = true;
    KeyAreaService.createLevel(levelName)
      .then(({ data }) => {
        this.levels.push({ ...data });
        this.levelSearchName = '';
      }).catch((err) => {
        VbSnackbarService.showError(err.response.data.messages.toString());
      }).finally(() => {
        this.loadingCreateLevel = false;
      })
  }

  selectedLevel(level: Level[]) {
    this.levelsSelected = level;
    const newLevels = level.filter(it => !this.keyArea.levels.some(lv => lv.id === it.id));
    this.keyArea.skillsActive.forEach((skill) => {
      skill.levels.push(new KeyAreaSkillLevel({
        id: newLevels[0].id,
        name: newLevels[0].name,
        active: true,
        expected: null,
        isDeletable: false,
      }))
    })
  }

  emitEvent(event: string, payload: any) {
    this.$emit(event, payload);
  }

  addNewIndicator(indicator: Indicators) {
    this.keyArea.indicators.push(indicator);
  }

  deleteIndicator(index: number) {
    this.$emit('deleteIndicator', index);
  }

  addNewResponsibility(data: ResponsibilityText) {
    this.keyArea.addNewResponsibility(data, this.levelsSelected);
  }

  get responsibilitiesActive() {
    return this.keyArea.responsibilities.filter(it => it.active);
  }

  skillAdded(skillId: string) {
    return this.keyArea.skills.some((s: any) => s.skill.id === skillId);
  }

  deleteResponsibility(index: number) {
    this.keyArea.responsibilities.splice(index, 1);
  }

  handleSkillOrdered(skills: KeyAreaSkill[]) {
    this.keyArea.skills = skills;
  }
}
